import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import {
    allStudents,
    allOCTDrClubShot,
    editOCTDriving,
} from 'Actions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class EditItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
        this.props.allOCTDrClubShot();
    }
    constructor(props) {

        super(props);
        this.state = {
            student: this.props.data.student,
            seldate: new Date(this.props.data.seldate),
            sepmore: this.props.data.sepmore,
            formValues: this.props.data.formValues,
            olddate: this.props.data.seldate,
            loader: false,
            editable: {},
            keycode: '',
        };
    }

    selstudent = (evt) => {
        var stdid = evt.value;
        this.setState({ student: stdid });
    }


    selectdate = (date) => {
        const seldate = moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate: date });

    }

    addHandleSubmit(event) {
        event.preventDefault();
        const { formValues } = this.state;

        const isAnyRowFilled = formValues.every((row) => {
            return (
                row.right !== "" || row.left !== ""
            );
        });

        if (isAnyRowFilled) {
            this.setState({ loader: true });
            var sepmore = this.state.sepmore;
            this.props.editOCTDriving(event, sepmore, this.state.olddate).then((data) => {
                if (data.status === 1) {
                    this.setState({
                        loader: false,
                    });
                }
            });
            setTimeout(() => {
                this.props.onClick();
            }, 2000);
        } else {
            alert("Please fill at least one of the fields (RIGHT (YDS), LEFT (YDS)");
        }
    }


    addFormFields() {
        var chktotal = this.state.sepmore;
        var totalsep = chktotal + 1;
        this.setState(({
            sepmore: totalsep,
            formValues: [...this.state.formValues, { clubused: "", right: "", left: "", area: "", contact: "", fairway: "0", missleft: "0", missright: "0", routine: "0" }]
        }))
    }

    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal = this.state.sepmore;
        var totalsep = chktotal - 1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore: totalsep });
    }

    handleNumberic(e) {
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        }
    }

    checkkey(e) {
        this.setState({ keycode: e.key });
    }

    handleChange(i, e) {
        var keyval = this.state.keycode;
        let formValues = this.state.formValues;
        var inputval = e.target.value;
        var digit = this.digits_count(inputval);

        if (e.target.name == 'right') {
            if (inputval == '') {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['left_' + i]: !editable['left_' + i] }
                }));
            } else if (digit == 1 && keyval == 'Backspace') {

            } else if (digit == 1) {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['left_' + i]: !editable['left_' + i] }
                }));
            }
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        } else if (e.target.name == 'left') {
            if (inputval == '') {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['right_' + i]: !editable['right_' + i] }
                }));
            } else if (digit == 1 && keyval == 'Backspace') {

            } else if (digit == 1) {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['right_' + i]: !editable['right_' + i] }
                }));
            }
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        } else if (e.target.name == 'clubused') {
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        } else if (e.target.name == 'contact') {
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        } else if (e.target.name == 'area') {
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });
        } else {

            var checkval = e.target.value;
            if (checkval == 1) {
                formValues[i][e.target.name] = 0;
                this.setState({ formValues });
            } else {
                formValues[i][e.target.name] = 1;
                this.setState({ formValues });
            }

            if (e.target.name == 'fairway') {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missleft_' + i]: !editable['missleft_' + i] }
                }));
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missright_' + i]: !editable['missright_' + i] }
                }));
            } else if (e.target.name == 'missleft') {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['fairway_' + i]: !editable['fairway_' + i] }
                }));
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missright_' + i]: !editable['missright_' + i] }
                }));
            } else if (e.target.name == 'missright') {
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['fairway_' + i]: !editable['fairway_' + i] }
                }));
                this.setState(({ editable }) => ({
                    editable: { ...editable, ['missleft_' + i]: !editable['missleft_' + i] }
                }));
            }
        }



    }

    digits_count(n) {
        var count = 0;
        if (n >= 0.1) ++count;

        while (n / 10 >= 1) {
            n /= 10;
            ++count;
        }
        return count;
    }




    render() {

        const { studentlists, octdrclubshot, loading } = this.props;
        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student,
                value: stdval.uudID
            }
        });

        const styles = {
            adbtn: {
                cursor: "pointer",
                color: "#7070f0",
                marginRight: "40px"
            },
            rembtn: {
                position: "relative",
                float: "right",
                marginTop: "-25px",
                marginRight: "20px",
                cursor: "pointer"
            }
        };

        return (
            <div>
                <div className="col-lg-12">
                    <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-10" style={{ margin: "0 auto" }}>
                                <RctCollapsibleCard heading="Edit Driving Test">
                                    <div className="row">
                                        <div className="col-sm-12 col-lg-4">
                                            <Label for="Select">Student *</Label>
                                            <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student' }} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required />
                                            </FormGroup>
                                        </div>

                                        <div className="col-sm-12 col-lg-4">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate" name="seldate" autoComplete="off" required
                                                    selected={this.state.seldate}
                                                    onChange={this.selectdate}
                                                    dateFormat='yyyy-MM-dd'
                                                    selectsEnd
                                                    maxDate={new Date()}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                />
                                            </FormGroup>
                                        </div>

                                        <div className="col-sm-12 col-lg-12">
                                            <div className="form-group">
                                                <div className="table-responsive">
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow hover>
                                                                <TableCell align="center" width={'15%'}>CLUB USED</TableCell>
                                                                <TableCell align="center" width={'10%'}>LEFT (YDS)</TableCell>
                                                                <TableCell align="center" width={'10%'}>RIGHT (YDS)</TableCell>
                                                                <TableCell align="center" width={'15%'}>CONTACT</TableCell>
                                                                <TableCell align="center" width={'10%'}>FAIRWAY HIT</TableCell>
                                                                <TableCell align="center" width={'15%'}>MISSED FAIRWAY LEFT</TableCell>
                                                                <TableCell align="center" width={'15%'}>MISSED FAIRWAY RIGHT</TableCell>
                                                                <TableCell align="center" width={'10%'}>PROCESS</TableCell>
                                                                <TableCell align="center" width={'10%'}>DELETE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                            {this.state.formValues.map((element, i) => (

                                                                <TableRow key={i}>
                                                                    <TableCell>
                                                                        <select name="clubused" id={"clubused_" + i} required className="form-control form-control-alternative"
                                                                            value={element.clubused || ""} onChange={e => this.handleChange(i, e)}>
                                                                            <option value=""> </option>
                                                                            {octdrclubshot.map((shotval) => (
                                                                                <option value={shotval.gcdID}>{shotval.gcd_club}</option>
                                                                            ))}
                                                                        </select>
                                                                    </TableCell>

                                                                    <TableCell><input type="text" name={'left'} id={'left_' + i} value={element.left || ""} disabled={(element.disleft == 0) ? !this.state.editable['left_' + i] : this.state.editable['left_' + i]} onKeyPress={e => this.handleNumberic(e)} onKeyDown={e => this.checkkey(e)} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell><input type="text" name={'right'} id={'right_' + i} value={element.right || ""} disabled={(element.disright == 0) ? !this.state.editable['right_' + i] : this.state.editable['right_' + i]} onKeyPress={e => this.handleNumberic(e)} onKeyDown={e => this.checkkey(e)} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell>
                                                                        <select
                                                                            name="contact"
                                                                            id={"contact_" + i}
                                                                            key={"contact_" + i} 
                                                                            className="form-control form-control-alternative"
                                                                            value={element.contact || ""}
                                                                            onChange={e => this.handleChange(i, e)}
                                                                            required
                                                                        >
                                                                            <option key="good" value="1">Good</option>
                                                                            <option key="bad" value="2">Bad</option>
                                                                        </select>
                                                                    </TableCell>
                                                                    <TableCell><input type="checkbox" name={'fairway'} id={'fairway_' + i} value={element.fairway} defaultChecked={element.disfair == 1 ? true : false} disabled={(element.disfair == 0) ? !this.state.editable['fairway_' + i] : this.state.editable['fairway_' + i]} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell><input type="checkbox" name={'missleft'} id={'missleft_' + i} value={element.missleft} defaultChecked={element.dismsleft == 1 ? true : false} disabled={(element.dismsleft == 0) ? !this.state.editable['missleft_' + i] : this.state.editable['missleft_' + i]} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell><input type="checkbox" name={'missright'} id={'missright_' + i} value={element.missright} defaultChecked={element.dismsright == 1 ? true : false} disabled={(element.dismsright == 0) ? !this.state.editable['missright_' + i] : this.state.editable['missright_' + i]} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell><input type="checkbox" name={'routine'} id={'routine_' + i} value={element.routine} defaultChecked={element.disroutine == 1 ? true : false} onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                                    <TableCell>
                                                                        <IconButton style={{ width: "10px", height: "10px" }} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton>

                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="dd">
                                                <button className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader}>Update</button>
                                                <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>
                                            </div>
                                        </div>
                                    </div>
                                </RctCollapsibleCard>
                            </div>
                        </div>
                    </form>
                </div>

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
            </div>

        )

    }

}

const mapStateToProps = ({ mostlyused, octdriving }) => {
    const { studentlists, loading } = mostlyused;
    const { octdrclubshot } = octdriving;
    return { studentlists, octdrclubshot, loading };

}


export default connect(mapStateToProps, {
    allStudents,
    allOCTDrClubShot,
    editOCTDriving,
})(EditItems);
